/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import AddressActions from '@Actions/addressActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import { Select } from 'antd';
import { Countries } from '@Apis/constants';
import { GetTallyConfigurations } from '../../../../modules/getTallyConfigurations';
import PRZSelect from '../../UI/PRZSelect';

/**
 *
 */
class UpdateAddressForm extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      productName: '',
      gstin: '',
      pinCodeShipping: '',
      district: '',
      addressShipping: '',
      stateShipping: '',
      uploadState: false,
      fileList: [],
      tallyAddressType: '',
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {*&{district: *, state: *}}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.addressObject && !state.addressObject) {
      const { addressObject } = props;
      return {
        ...state,
        address: addressObject?.address1,
        district: addressObject?.city,
        state: addressObject?.state,
        pinCode: addressObject?.postal_code,
        country: addressObject?.country,
        tallyAddressType: addressObject?.tally_address_type,
        addressObject,
      };
    }
    if (props.pincodeCity) {
      const city = props.pincodeCity;
      const cityState = props.pincodeState;
      props.setCityState(null, null);
      return {
        ...state, district: city, state: cityState,
      };
    }
    return state;
  }

  /**
   *
   */
  componentDidMount() {
    const { getTallyConfigurations, user } = this.props;

    if (this.isTallyConnected()) {
      getTallyConfigurations({
        query: {
          org_id: user?.org_id,
          column_type: 'ADDRESS',
        },
      }, () => {});
    }
  }

  /**
   *
   */
  updateAddress = () => {
    this.setState({ formSubmitted: true });
    const {
      address, district, state, pinCode, country, tallyAddressType,
    } = this.state;
    const {
      seller, updateAddress, addressType, selectedTenantId, addressObject, documentType, entityId,
    } = this.props;
    const { callback, user } = this.props;

    const selectedEntityId = documentType === 'STOCK_TRANSFER' ? entityId : addressType === 'SELLER' ? seller.seller_id : selectedTenantId || user?.tenant_info?.tenant_id;

    if (address && district && state && pinCode) {
      const payload = {
        address_id: addressObject?.address_id,
        address1: address,
        address2: '',
        address3: '',
        city: district,
        state,
        country,
        postal_code: pinCode,
        entity_type: addressType,
        entity_id: selectedEntityId,
        tally_address_type: tallyAddressType,
      };
      updateAddress(payload, (addressResponse) => {
        callback(addressResponse);
        this.setState({
          address: '',
          district: '',
          state: '',
          pinCode: '',
          formSubmitted: false,
          addressObject: null,
          tallyAddressType: '',
        });
      });
    }
  }

  isTallyConnected = () => {
    const { user, tenantId } = this.props;

    const orgId = user?.org_id;

    const tallyTenant = user?.user_tenants?.find((item) => (item?.org_id === orgId && item?.tenant_id === tenantId));

    return !!tallyTenant?.it_id;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      updateAddressLoading, getCityState, tallyConfigurations, tallyConfigurationsLoading,
    } = this.props;
    const {
      formSubmitted, address, district, state, pinCode, country, tallyAddressType,
    } = this.state;
    return (
      <div className="ant-row">
        <div className="ant-col-md-24 ant-col-xs-24">
          <div className="orgInputContainer">
            <H3FormInput
              isTextarea
              name="street address"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput address-text-area"
              placeholder=""
              onChange={(event) => this.setState({ address: event.target.value })}
              value={address}
              label="Street"
              showError={formSubmitted && !address}
              required
              disabled={updateAddressLoading}
            />
          </div>
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="a valid pincode"
            type="number"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => (event.target.value.length <= 6 ? this.setState({ pinCode: event.target.value }) : '')}
            onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
            value={pinCode}
            label="Pin Code"
            required
            showError={formSubmitted && !pinCode}
            disabled={updateAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="district"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => this.setState({ district: event.target.value })}
            value={district}
            label="District"
            showError={formSubmitted && !district}
            required
            disabled={updateAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <H3FormInput
            name="state"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => this.setState({ state: event.target.value })}
            value={state}
            label="State"
            showError={formSubmitted && !state}
            required
            disabled={updateAddressLoading}
          />
        </div>
        <div className="ant-col-md-24 ant-col-xs-24">
          <label className="orgFormLabel"> Country</label>
          <PRZSelect
            value={country}
            disabled={updateAddressLoading}
            showSearch
            style={{
              marginTop: '1px',
              marginBottom: '12px',
            }}
            placeholder=""
            onChange={(value) => {
              this.setState({
                country: value,
              });
            }}
            showError={formSubmitted && !country}
            errorName="*Please enter country"
            errorClassName="input-error"
          >
            {Countries?.map((ctr) => <Option key={ctr.code} value={ctr.name}>{ctr.name?.toProperCase()}</Option>)}
          </PRZSelect>
        </div>
        {this.isTallyConnected() && (
          <div className="ant-col-md-24 ant-col-xs-24">
            <label className="orgFormLabel"> Tally Address Type</label>
            <PRZSelect
              value={tallyAddressType}
              disabled={updateAddressLoading || tallyConfigurationsLoading}
              onChange={(value) => {
                this.setState({
                  tallyAddressType: value,
                });
              }}
            >
              {tallyConfigurations?.tally_address_types?.map((item) => (
                <Option key={item?.address_type}>
                  {item?.address_type}
                </Option>
              ))}
            </PRZSelect>
          </div>
        )}
        <div className="ant-col-md-6" style={{ marginTop: '20px' }}>
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Update Address"
            onClick={() => this.updateAddress()}
            isLoading={updateAddressLoading}
            disabled={updateAddressLoading}
            style={{
              width: '200px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({
  SellerReducers, AddressReducer, GetTallyConfigurations, UserReducers,
}) => ({
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  updateAddressLoading: AddressReducer.updateAddressLoading,
  tallyConfigurations: GetTallyConfigurations.data,
  tallyConfigurationsLoading: GetTallyConfigurations.loading,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  updateAddress: (payload, callback) => dispatch(AddressActions.updateAddress(payload, callback)),
  getTallyConfigurations: (payload, callback) => dispatch(GetTallyConfigurations.actions.request(payload, callback)),
});

UpdateAddressForm.propTypes = {
  pincodeCity: PropTypes.string,
  pincodeState: PropTypes.string,
  setCityState: PropTypes.func,
  addressObject: PropTypes.any,
  user: PropTypes.any,
  callback: PropTypes.any,
  seller: PropTypes.any,
  updateAddress: PropTypes.func,
  updateAddressLoading: PropTypes.bool,
  addressType: PropTypes.string,
  selectedTenantId: PropTypes.any,
  getCityState: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateAddressForm));
